/**
 * External dependencies
 */
import { Reducer } from 'redux';

/**
 * Internal dependencies
 */
import { setEventResponsesLoading } from '@/store/actions';
import initialState from '../../initialState';
import isAction from '../../isAction';

const error: Reducer<boolean | null> = (
	state = initialState.currentEvent.error,
	action
) => (isAction(action, setEventResponsesLoading) ? action.payload : state);

export default error;
